import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import financialApi from '../utils/financialApi';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const nf = (n) => { const v = Math.round((Number(n) || 0) * 1000) / 1000; return v.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: Math.abs(v % 1) > 0.0005 ? 3 : 0 }); };
const fmtDate = (d) => { if (!d) return '—'; const x = new Date(d); return `${String(x.getDate()).padStart(2, '0')}/${String(x.getMonth() + 1).padStart(2, '0')}/${x.getFullYear()}`; };
const fmtDateTime = (d) => { if (!d) return '—'; const x = new Date(d); return `${fmtDate(d)} ${String(x.getHours()).padStart(2, '0')}:${String(x.getMinutes()).padStart(2, '0')}`; };
const varColor = (v) => v > 0 ? '#DC2626' : v < 0 ? '#16A34A' : '#6B7280';

function Modal({ title, onClose, children, width = 460 }) {
  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 12, width, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,.25)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #E5E7EB', display: 'flex', alignItems: 'center' }}>
          <h3 style={{ fontSize: 15, fontWeight: 800, flex: 1, margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', color: '#6B7280' }}>×</button>
        </div>
        <div style={{ padding: 20 }}>{children}</div>
      </div>
    </div>
  );
}
const inp = { width: '100%', padding: '9px 11px', border: '1px solid #D1D5DB', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' };

// Baseline approval workflow banner (submit → approver approves/rejects → frozen).
function BaselineBanner({ spaceId, kind, year, state, onChange, canManage = true }) {
  const [users, setUsers] = useState([]);
  const [picking, setPicking] = useState(false);
  const [approverId, setApproverId] = useState('');
  const [confirmDel, setConfirmDel] = useState(false);
  useEffect(() => { financialApi.get(`/projects/${spaceId}/users`).then(setUsers).catch(() => {}); }, [spaceId]);
  const act = async (action, body) => { try { await financialApi.post(`/projects/${spaceId}/${kind}/baseline-${action}`, body || {}); setPicking(false); onChange(); } catch (e) { alert(e.error || 'Failed'); } };
  const status = state.status || 'draft';
  const bg = status === 'approved' ? '#ECFDF5' : status === 'pending' ? '#EFF6FF' : '#FFFBEB';
  const bd = status === 'approved' ? '#A7F3D0' : status === 'pending' ? '#BFDBFE' : '#FCD34D';
  const col = status === 'approved' ? '#15803D' : status === 'pending' ? '#1D4ED8' : '#B45309';
  return (
    <div style={{ padding: '10px 12px', borderRadius: 8, marginBottom: 12, background: bg, border: `1px solid ${bd}` }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12.5, fontWeight: 700, color: col }}>
          {status === 'approved' && `✓ Baseline approved & frozen${state.approved_by_name ? ` by ${state.approved_by_name}` : ''}`}
          {status === 'pending' && `⏳ Pending approval${state.approver_name ? ` by ${state.approver_name}` : ''}${state.submitted_by_name ? ` · submitted by ${state.submitted_by_name}` : ''}`}
          {status === 'draft' && 'Baseline is in draft'}
        </span>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
          {canManage && status === 'approved' && <button onClick={() => act('reopen')} style={{ ...btn('#fff', '#B45309'), borderColor: '#FCD34D', padding: '6px 12px' }}>Reopen for editing</button>}
          {canManage && status === 'pending' && <>
            <button onClick={() => act('approve')} style={{ ...btn('#16A34A'), padding: '6px 12px' }}>Approve &amp; freeze</button>
            <button onClick={() => act('reject')} style={{ ...btn('#fff', '#DC2626'), borderColor: '#FECACA', padding: '6px 12px' }}>Reject</button>
          </>}
          {canManage && status === 'draft' && !picking && <button onClick={() => setPicking(true)} style={{ ...btn('#4F46E5'), padding: '6px 12px' }}>Submit for approval</button>}
          {canManage && <button onClick={() => setConfirmDel(true)} style={{ ...btn('#fff', '#DC2626'), borderColor: '#FECACA', padding: '6px 12px' }}>Delete &amp; reconfigure</button>}
        </div>
      </div>
      {canManage && status === 'draft' && picking && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10 }}>
          <span style={{ fontSize: 12, color: '#6B7280' }}>Approver:</span>
          <select value={approverId} onChange={e => setApproverId(e.target.value)} style={{ ...inp, width: 'auto', flex: 1, maxWidth: 280 }}>
            <option value="">Select an approver…</option>
            {users.map(u => <option key={u.id} value={u.id}>{u.full_name}</option>)}
          </select>
          <button onClick={() => approverId && act('submit', { approver_id: approverId })} disabled={!approverId} style={{ ...btn('#4F46E5'), padding: '6px 12px' }}>Send</button>
          <button onClick={() => setPicking(false)} style={{ ...btn('#F3F4F6', '#374151'), padding: '6px 12px' }}>Cancel</button>
        </div>
      )}
      {status === 'pending' && <div style={{ fontSize: 11.5, color: '#6B7280', marginTop: 6 }}>The chosen approver (or a project manager) can approve or reject. The plan stays editable until approved.</div>}
      {confirmDel && <ConfirmModal title="Delete & reconfigure baseline"
        message={`This clears the Baseline monthly plan for FY ${year} and resets it to draft so you can reconfigure it. The action is recorded in the Audit Trail and cannot be undone.`}
        confirmLabel="Delete baseline" onConfirm={async () => { await act('delete', { fin_year: year }); setConfirmDel(false); }} onClose={() => setConfirmDel(false)} />}
    </div>
  );
}

// In-app confirmation modal (replaces window.confirm).
function ConfirmModal({ title, message, confirmLabel = 'Delete', danger = true, onConfirm, onClose }) {
  const [busy, setBusy] = useState(false);
  return (
    <Modal title={title} onClose={onClose} width={420}>
      <p style={{ fontSize: 13, color: '#4B5563', lineHeight: 1.6, marginTop: 0 }}>{message}</p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Cancel</button>
        <button disabled={busy} onClick={async () => { setBusy(true); try { await onConfirm(); } finally { setBusy(false); } }}
          style={btn(danger ? '#DC2626' : '#4F46E5')}>{busy ? 'Working…' : confirmLabel}</button>
      </div>
    </Modal>
  );
}
const lbl = { fontSize: 12, fontWeight: 600, color: '#6B7280', marginBottom: 5, display: 'block' };
const btn = (bg = '#4F46E5', c = '#fff') => ({ padding: '9px 16px', background: bg, color: c, border: '1px solid ' + bg, borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' });
const card = { background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12, padding: 18, marginBottom: 18 };
const th = { padding: '9px 12px', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '.4px', textAlign: 'left', borderBottom: '1px solid #E5E7EB' };
const td = { padding: '9px 12px', fontSize: 13, borderBottom: '1px solid #F1F3F5' };

export default function FinancialAnalysisPage() {
  const { spaceId } = useParams();
  const navigate = useNavigate();
  const [access, setAccess] = useState(null);
  const [tab, setTab] = useState('overview');
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [exporting, setExporting] = useState(false);
  const [projectName, setProjectName] = useState('Project');
  const years = Array.from({ length: (2035 - 2022) + 1 }, (_, i) => 2035 - i);
  useEffect(() => {
    financialApi.get(`/projects/${spaceId}/access`).then(setAccess).catch(() => setAccess({ has_access: false, can_manage_roles: false }));
    financialApi.get(`/projects/${spaceId}/users`).catch(() => {}); // warm
  }, [spaceId]);
  useEffect(() => {
    // Project name for the export filename/header (best-effort).
    fetch(`/api/spaces/${spaceId}`, { headers: { Authorization: `Bearer ${localStorage.getItem('flowup_token')}` } })
      .then(r => r.ok ? r.json() : null).then(d => { if (d && d.name) setProjectName(d.name); }).catch(() => {});
  }, [spaceId]);

  const doExport = async () => {
    setExporting(true);
    try {
      const { exportFinancialWorkbook } = await import('../utils/financialWorkbook');
      await exportFinancialWorkbook(spaceId, {
        projectName, year, month: year === 'all' ? null : month,
        monthLabel: year === 'all' ? null : MONTHS[month - 1],
      });
    } catch (e) {
      alert((e && e.error) || 'Could not generate the Excel report.');
    } finally { setExporting(false); }
  };

  if (access === null) return <div style={{ padding: 40, color: '#6B7280' }}>Loading…</div>;
  if (!access.has_access) {
    return (
      <div style={{ padding: 40, maxWidth: 600 }}>
        <button onClick={() => navigate(`/spaces/${spaceId}`)} style={{ ...btn('#F3F4F6', '#374151'), marginBottom: 20 }}>← Back to project</button>
        <div style={{ ...card, textAlign: 'center', padding: 40 }}>
          <div style={{ fontSize: 38, marginBottom: 10 }}>🔒</div>
          <h2 style={{ fontSize: 17, fontWeight: 800, marginBottom: 8 }}>Financial Analysis is restricted</h2>
          <p style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.6 }}>
            Only assigned Financial Project Managers can view this tab. Ask the project creator or a project manager to assign you.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '24px 32px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6, gap: 12 }}>
        <button onClick={() => navigate(`/spaces/${spaceId}`)} style={btn('#F3F4F6', '#374151')}>← Project</button>
        <h1 style={{ fontSize: 22, fontWeight: 800, margin: 0, flex: 1 }}>💵 Financial Analysis</h1>
        {year !== 'all' && (
          <select value={month} onChange={e => setMonth(parseInt(e.target.value))} style={{ ...inp, width: 'auto' }} title="Show data cumulatively up to this month">
            {MONTHS.map((m, i) => <option key={i} value={i + 1}>Up to {m}</option>)}
          </select>
        )}
        <select value={year} onChange={e => setYear(e.target.value === 'all' ? 'all' : parseInt(e.target.value))} style={{ ...inp, width: 'auto' }}>
          <option value="all">All years</option>
          {years.map(y => <option key={y} value={y}>FY {y}</option>)}
        </select>
        <button onClick={doExport} disabled={exporting} style={{ ...btn('#16A34A'), whiteSpace: 'nowrap' }} title="Download a professional multi-sheet Excel report of the financial analysis">
          {exporting ? 'Generating…' : '⬇ Export Excel'}
        </button>
        <button onClick={() => setTab('audit')} style={{ ...btn(tab === 'audit' ? '#4F46E5' : '#F3F4F6', tab === 'audit' ? '#fff' : '#374151'), whiteSpace: 'nowrap' }} title="View the financial audit trail">
          🕑 Audit Trail
        </button>
      </div>
      <p style={{ fontSize: 13, color: '#6B7280', marginTop: 0, marginBottom: 18 }}>Project-level CAPEX and OPEX monitoring with automatic, real-time calculations.</p>

      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid #E5E7EB', marginBottom: 20, flexWrap: 'wrap' }}>
        {[['overview', '📊 Overview'], ['capex', 'CAPEX'], ['opex', 'OPEX'], ['funding', 'Funding Status'], ['financing', 'Financing Updates'], ...(access.can_manage_roles ? [['roles', 'Financial PMs']] : [])].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)}
            style={{ padding: '9px 18px', background: 'none', border: 'none', borderBottom: `2px solid ${tab === k ? '#4F46E5' : 'transparent'}`, color: tab === k ? '#4F46E5' : '#6B7280', fontWeight: tab === k ? 700 : 500, fontSize: 13, cursor: 'pointer', marginBottom: -1 }}>{l}</button>
        ))}
      </div>

      {tab === 'overview' && <OverviewSection spaceId={spaceId} year={year} month={month} />}
      {tab === 'capex' && <CapexSection spaceId={spaceId} year={year} month={month} canManage={access.fin_role === 'manager'} />}
      {tab === 'opex' && <OpexSection spaceId={spaceId} year={year} month={month} canManage={access.fin_role === 'manager'} />}
      {tab === 'funding' && <FundingSection spaceId={spaceId} />}
      {tab === 'financing' && <FinancingSection spaceId={spaceId} />}
      {tab === 'audit' && <AuditSection spaceId={spaceId} />}
      {tab === 'roles' && <RolesSection spaceId={spaceId} />}
    </div>
  );
}

// ══════════════════════════════ CAPEX ══════════════════════════════
// Shared month filter control
function CapexSection({ spaceId, year, month, canManage = true }) {
  const KIND = 'capex';
  const planYear = year === 'all' ? new Date().getFullYear() : year;
  const [cats, setCats] = useState([]);
  const [entries, setEntries] = useState([]);
  const [planBaseline, setPlanBaseline] = useState([]);
  const [planRolling, setPlanRolling] = useState([]);
  const [baseState, setBaseState] = useState({ status: 'draft' });
  const [actualGrid, setActualGrid] = useState({});
  const [dash, setDash] = useState(null);
  const [view, setView] = useState('dashboard');
  const [planType, setPlanType] = useState('baseline');
  const [catModal, setCatModal] = useState(null);
  const [entryModal, setEntryModal] = useState(null);
  const [planCat, setPlanCat] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [copyMsg, setCopyMsg] = useState('');

  const load = useCallback(() => {
    financialApi.get(`/projects/${spaceId}/capex/categories`).then(setCats).catch(() => {});
    financialApi.get(`/projects/${spaceId}/capex/entries`).then(setEntries).catch(() => {});
    financialApi.get(`/projects/${spaceId}/capex/plan?plan_type=baseline`).then(setPlanBaseline).catch(() => {});
    financialApi.get(`/projects/${spaceId}/capex/plan?plan_type=rolling`).then(setPlanRolling).catch(() => {});
    financialApi.get(`/projects/${spaceId}/capex/baseline-state`).then(setBaseState).catch(() => {});
    financialApi.get(`/projects/${spaceId}/capex/actual-expenditure?year=${planYear}`).then(r => setActualGrid(r.grid || {})).catch(() => {});
    financialApi.get(`/projects/${spaceId}/capex/dashboard?year=${year}&month=${month}`).then(setDash).catch(() => {});
  }, [spaceId, year, month, planYear]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { const f = () => load(); window.addEventListener('focus', f); const t = setInterval(load, 20000); return () => { window.removeEventListener('focus', f); clearInterval(t); }; }, [load]);

  const catName = id => (cats.find(c => c.id === id) || {}).name || '—';
  const plan = planType === 'baseline' ? planBaseline : planRolling;
  const baselineApproved = baseState.status === 'approved';


  return (
    <div>
      <div style={{ display: 'flex', gap: 4, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['dashboard', 'Dashboard'], ['categories', 'Budget Setup'], ['plan', 'Monthly Budget Plan'], ['actual', 'Actual Expenditure'], ['entries', 'Expenditure Entries']].map(([k, l]) => (
          <button key={k} onClick={() => setView(k)} style={{ ...btn(view === k ? '#EEF2FF' : '#fff', view === k ? '#4F46E5' : '#6B7280'), borderColor: '#E5E7EB' }}>{l}</button>
        ))}
      </div>
      {copyMsg && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#EEF2FF', border: '1px solid #C7D2FE', color: '#3730A3', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>
          <span style={{ flex: 1 }}>{copyMsg}</span>
          <button onClick={() => setCopyMsg('')} style={{ ...btn('#fff', '#4F46E5'), borderColor: '#C7D2FE', padding: '4px 10px', fontSize: 12 }}>Dismiss</button>
        </div>
      )}



      {view === 'dashboard' && dash && (
        <div style={card}>
          <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 0 }}>CAPEX Performance — {dash.year === 'all' ? 'All years' : `FY ${dash.year}`}{dash.up_to_month && year !== 'all' ? ` (through ${MONTHS[dash.up_to_month - 1]})` : ''}</h3>
          <p style={{ fontSize: 11.5, color: '#9CA3AF', marginTop: 0, marginBottom: 12 }}>Actuals from expenditure entries; YTD Budget from the Rolling monthly budget plan; cumulative to the selected month.</p>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>
                <th style={th}>Description</th><th style={{ ...th, textAlign: 'right' }}>Project Budget</th>
                <th style={{ ...th, textAlign: 'right' }}>ITD Actual</th><th style={{ ...th, textAlign: 'right' }}>Remaining</th><th style={{ ...th, textAlign: 'right' }}>YTD Actual</th>
                <th style={{ ...th, textAlign: 'right' }}>YTD Budget</th><th style={{ ...th, textAlign: 'right' }}>Variance %</th>
              </tr></thead>
              <tbody>
                {dash.rows.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={7}>No CAPEX categories yet. Add them under Budget Setup.</td></tr>}
                {dash.rows.map(r => (
                  <tr key={r.id}>
                    <td style={{ ...td, fontWeight: 600 }}>{r.name}</td>
                    <td style={{ ...td, textAlign: 'right' }}>{nf(r.project_budget)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>{nf(r.itd_actual)}</td>
                    <td style={{ ...td, textAlign: 'right', color: r.remaining < 0 ? '#DC2626' : '#111827' }}>{nf(r.remaining)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>{nf(r.ytd_actual)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>{nf(r.ytd_budget)}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: varColor(r.variance_pct) }}>{r.variance_pct >= 0 ? '+' : ''}{nf(r.variance_pct)}%</td>
                  </tr>
                ))}
              </tbody>
              {dash.rows.length > 0 && <tfoot><tr style={{ background: '#F9FAFB', fontWeight: 800 }}>
                <td style={{ ...td, fontWeight: 800 }}>Total</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.project_budget)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.itd_actual)}</td>
                <td style={{ ...td, textAlign: 'right', color: dash.totals.remaining < 0 ? '#DC2626' : '#111827' }}>{nf(dash.totals.remaining)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.ytd_actual)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.ytd_budget)}</td>
                <td style={{ ...td, textAlign: 'right', color: varColor(dash.totals.variance_pct) }}>{dash.totals.variance_pct >= 0 ? '+' : ''}{nf(dash.totals.variance_pct)}%</td>
              </tr></tfoot>}
            </table>
          </div>
        </div>
      )}

      {view === 'categories' && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
            <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, flex: 1 }}>CAPEX Budget Categories</h3>
            {canManage && <button onClick={() => setCatModal({})} style={btn()}>+ Add Category</button>}
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Category</th><th style={{ ...th, textAlign: 'right' }}>Project Budget</th><th style={th}>Notes</th><th style={th}>Last modified</th><th style={th}></th></tr></thead>
            <tbody>
              {cats.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={5}>No categories yet.</td></tr>}
              {cats.map(c => {
                const drow = dash && dash.rows.find(r => r.id === c.id);
                return (
                <tr key={c.id}>
                  <td style={{ ...td, fontWeight: 600 }}>{c.name}</td>
                  <td style={{ ...td, textAlign: 'right' }} title="From the Baseline monthly budget plan">{drow ? nf(drow.project_budget) : '—'}</td>
                  <td style={{ ...td, color: '#6B7280' }}>{c.notes || '—'}</td>
                  <td style={{ ...td, color: '#9CA3AF', fontSize: 11 }}>{c.modified_by_name || c.created_by_name || '—'}<br />{fmtDateTime(c.modified_at || c.created_at)}</td>
                  <td style={{ ...td, textAlign: 'right' }}>
                    {canManage ? <>
                    <button onClick={() => setCatModal(c)} style={{ ...btn('#F3F4F6', '#374151'), padding: '5px 10px', marginRight: 6 }}>Edit</button>
                    <button onClick={() => setConfirm({ title: 'Delete category', message: 'Delete this category along with its plan and expenditure entries? This cannot be undone.', run: async () => { await financialApi.delete(`/projects/${spaceId}/capex/categories/${c.id}`); setConfirm(null); load(); } })} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '5px 10px', borderColor: '#FECACA' }}>Delete</button>
                    </> : <span style={{ color: '#D1D5DB', fontSize: 12 }}>—</span>}
                  </td>
                </tr>
                );
              })}
            </tbody>
          </table>
          <div style={{ fontSize: 11.5, color: '#9CA3AF', marginTop: 10 }}>Project Budget is the sum of each category's Baseline monthly budget plan. Set it under Monthly Budget Plan → Baseline.</div>
        </div>
      )}

      {view === 'plan' && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
            <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0 }}>Monthly Budget Plan — FY {planYear}</h3>
            <div style={{ display: 'flex', gap: 4, marginLeft: 'auto' }}>
              <button onClick={() => setPlanType('baseline')} style={{ ...btn(planType === 'baseline' ? '#EEF2FF' : '#fff', planType === 'baseline' ? '#4F46E5' : '#6B7280'), borderColor: '#E5E7EB', padding: '6px 12px' }}>Baseline</button>
              <button onClick={() => setPlanType('rolling')} style={{ ...btn(planType === 'rolling' ? '#EEF2FF' : '#fff', planType === 'rolling' ? '#4F46E5' : '#6B7280'), borderColor: '#E5E7EB', padding: '6px 12px' }}>Rolling</button>
            </div>
          </div>
          {planType === 'baseline' && <BaselineBanner spaceId={spaceId} kind={KIND} year={planYear} state={baseState} onChange={load} canManage={canManage} />}
          {planType === 'rolling' && (
            <div style={{ marginBottom: 10 }}>
              <button onClick={() => setConfirm({ title: 'Copy from Baseline', message: `Copy the Baseline plan into the Rolling plan for FY ${planYear}? This overwrites the rolling cells for this year.`, confirmLabel: 'Copy', danger: false, run: async () => { try { await financialApi.post(`/projects/${spaceId}/${KIND}/plan/copy-baseline-to-rolling`, { fin_year: planYear }); setConfirm(null); setCopyMsg(`Baseline copied into the rolling plan for FY ${planYear}.`); load(); } catch (e) { setConfirm(null); setCopyMsg(e.error || 'Copy failed.'); } } })} style={{ ...btn('#4F46E5'), padding: '6px 14px', fontSize: 12.5 }}>⧉ Copy from Baseline</button>
              <span style={{ fontSize: 11.5, color: '#9CA3AF', marginLeft: 10 }}>Pulls the baseline figures into rolling so you can adjust them — available even before the baseline is approved.</span>
            </div>
          )}
          <p style={{ fontSize: 12, color: '#6B7280', marginTop: 0 }}>
            {planType === 'baseline' ? 'The approved baseline is the fixed comparison basis for variance. ' : 'The rolling plan is your working forecast and can change anytime. '}
            Click a cell to edit. Used to compute YTD Budget.
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
              <thead><tr><th style={th}>Category</th>{MONTHS.map(m => <th key={m} style={{ ...th, textAlign: 'right' }}>{m}</th>)}<th style={{ ...th, textAlign: 'right' }}>Total</th></tr></thead>
              <tbody>
                {cats.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={14}>Add categories first.</td></tr>}
                {cats.map(c => {
                  const rowTotal = plan.filter(p => p.category_id === c.id && p.fin_year === planYear).reduce((s, p) => s + Number(p.planned_budget || 0), 0);
                  return (
                    <tr key={c.id}>
                      <td style={{ ...td, fontWeight: 600, position: 'sticky', left: 0, background: '#fff' }}>{c.name}</td>
                      {MONTHS.map((m, i) => {
                        const cell = plan.find(p => p.category_id === c.id && p.fin_year === planYear && p.month === i + 1);
                        const editable = planType === 'rolling' ? true : (canManage && !baselineApproved);
                        return (
                          <td key={i} style={{ ...td, textAlign: 'right', cursor: editable ? 'pointer' : 'default', color: cell ? '#111827' : '#D1D5DB' }}
                            onClick={() => editable && setPlanCat({ category_id: c.id, name: c.name, month: i + 1, plan_type: planType, planned_budget: cell ? cell.planned_budget : '' })}>
                            {cell ? nf(cell.planned_budget) : '–'}
                          </td>
                        );
                      })}
                      <td style={{ ...td, textAlign: 'right', fontWeight: 700 }}>{nf(rowTotal)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {view === 'actual' && (
        <div style={card}>
          <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 0 }}>Actual Expenditure — FY {planYear}</h3>
          <p style={{ fontSize: 12, color: '#6B7280', marginTop: 0 }}>Built automatically from expenditure entries, per category and month. Add entries under "Expenditure Entries".</p>
          <div style={{ marginBottom: 10 }}>
            <button onClick={() => setConfirm({ title: 'Copy from Baseline', message: `Create actual expenditure entries from the Baseline plan for FY ${planYear}? Existing baseline-copied entries for this year are replaced; you can then edit them under Expenditure Entries.`, confirmLabel: 'Copy', danger: false, run: async () => { try { const r = await financialApi.post(`/projects/${spaceId}/${KIND}/copy-baseline-to-actual`, { fin_year: planYear }); setConfirm(null); setCopyMsg(`Created ${r.created} entries from baseline. Edit them under Expenditure Entries.`); load(); } catch (e) { setConfirm(null); setCopyMsg(e.error || 'Copy failed.'); } } })} style={{ ...btn('#4F46E5'), padding: '6px 14px', fontSize: 12.5 }}>⧉ Copy from Baseline</button>
            <span style={{ fontSize: 11.5, color: '#9CA3AF', marginLeft: 10 }}>Generates editable actual entries (dated mid-month) from the baseline, then adjust them under Expenditure Entries.</span>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
              <thead><tr><th style={th}>Category</th>{MONTHS.map(m => <th key={m} style={{ ...th, textAlign: 'right' }}>{m}</th>)}<th style={{ ...th, textAlign: 'right' }}>Total</th></tr></thead>
              <tbody>
                {cats.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={14}>No categories yet.</td></tr>}
                {cats.map(c => {
                  const row = actualGrid[c.id] || {};
                  const rowTotal = Object.values(row).reduce((s, v) => s + Number(v || 0), 0);
                  return (
                    <tr key={c.id}>
                      <td style={{ ...td, fontWeight: 600, position: 'sticky', left: 0, background: '#fff' }}>{c.name}</td>
                      {MONTHS.map((m, i) => <td key={i} style={{ ...td, textAlign: 'right', color: row[i + 1] ? '#111827' : '#D1D5DB' }}>{row[i + 1] ? nf(row[i + 1]) : '–'}</td>)}
                      <td style={{ ...td, textAlign: 'right', fontWeight: 700 }}>{nf(rowTotal)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {view === 'entries' && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
            <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, flex: 1 }}>CAPEX Expenditure Entries</h3>
            <button onClick={() => setEntryModal({})} style={btn()} disabled={cats.length === 0}>+ Add Entry</button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Date</th><th style={th}>Category</th><th style={th}>Description</th><th style={th}>Reference</th><th style={{ ...th, textAlign: 'right' }}>Amount</th><th style={th}>Entered by</th><th style={th}></th></tr></thead>
            <tbody>
              {(() => {
                const list = year === 'all' ? entries : entries.filter(e => { const d = new Date(e.entry_date); return d.getUTCFullYear() === planYear && (d.getUTCMonth() + 1) <= month; });
                if (list.length === 0) return <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={7}>No expenditures in this period.</td></tr>;
                return list.map(e => (
                  <tr key={e.id}>
                    <td style={td}>{fmtDate(e.entry_date)}</td>
                    <td style={{ ...td, fontWeight: 600 }}>{catName(e.category_id)}</td>
                    <td style={td}>{e.description || '—'}</td>
                    <td style={{ ...td, color: '#6B7280' }}>{e.reference_no || '—'}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{nf(e.amount)}</td>
                    <td style={{ ...td, color: '#9CA3AF', fontSize: 11 }}>{e.created_by_name || '—'}<br />{fmtDateTime(e.created_at)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>
                      <button onClick={() => setEntryModal(e)} style={{ ...btn('#F3F4F6', '#374151'), padding: '5px 10px', marginRight: 6 }}>Edit</button>
                      <button onClick={() => setConfirm({ title: 'Delete entry', message: 'Delete this expenditure entry? This cannot be undone.', run: async () => { await financialApi.delete(`/projects/${spaceId}/capex/entries/${e.id}`); setConfirm(null); load(); } })} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '5px 10px', borderColor: '#FECACA' }}>Delete</button>
                    </td>
                  </tr>
                ));
              })()}
            </tbody>
          </table>
        </div>
      )}

      {catModal && <CatModal spaceId={spaceId} cat={catModal} onClose={() => setCatModal(null)} onSaved={() => { setCatModal(null); load(); }} />}
      {entryModal && <EntryModal spaceId={spaceId} kind="capex" entry={entryModal} cats={cats} onClose={() => setEntryModal(null)} onSaved={() => { setEntryModal(null); load(); }} />}
      {planCat && <PlanModal spaceId={spaceId} kind="capex" year={planYear} data={planCat} onClose={() => setPlanCat(null)} onSaved={() => { setPlanCat(null); load(); }} />}
      {confirm && <ConfirmModal title={confirm.title} message={confirm.message} confirmLabel={confirm.confirmLabel || 'Confirm'} danger={confirm.danger !== false ? confirm.danger : false} onConfirm={confirm.run} onClose={() => setConfirm(null)} />}
    </div>
  );
}

function CatModal({ spaceId, cat, onClose, onSaved }) {
  const [name, setName] = useState(cat.name || '');
  const [notes, setNotes] = useState(cat.notes || '');
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!name.trim()) return; setBusy(true);
    try {
      if (cat.id) await financialApi.put(`/projects/${spaceId}/capex/categories/${cat.id}`, { name, notes });
      else await financialApi.post(`/projects/${spaceId}/capex/categories`, { name, notes });
      onSaved();
    } catch (e) { alert(e.error || 'Failed'); setBusy(false); }
  };
  return (
    <Modal title={cat.id ? 'Edit Category' : 'New CAPEX Category'} onClose={onClose}>
      <label style={lbl}>Category name</label>
      <input style={inp} value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Civil Works" />
      <label style={{ ...lbl, marginTop: 12 }}>Notes</label>
      <textarea style={{ ...inp, minHeight: 60 }} value={notes} onChange={e => setNotes(e.target.value)} />
      <div style={{ fontSize: 11.5, color: '#9CA3AF', marginTop: 10 }}>The Project Budget is calculated automatically from this category's Baseline monthly budget plan.</div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Cancel</button>
        <button onClick={save} disabled={busy} style={btn()}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
    </Modal>
  );
}

function PlanModal({ spaceId, kind = 'capex', year, data, onClose, onSaved }) {
  const [val, setVal] = useState(data.planned_budget ?? '');
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await financialApi.post(`/projects/${spaceId}/${kind}/plan`, { category_id: data.category_id, fin_year: year, month: data.month, plan_type: data.plan_type || 'baseline', planned_budget: val }); onSaved(); }
    catch (e) { alert(e.error || 'Failed'); setBusy(false); }
  };
  return (
    <Modal title={`${(data.plan_type || 'baseline') === 'baseline' ? 'Baseline' : 'Rolling'} plan — ${data.name}, ${MONTHS[data.month - 1]} ${year}`} onClose={onClose} width={380}>
      <label style={lbl}>Planned budget</label>
      <input style={inp} type="number" autoFocus value={val} onChange={e => setVal(e.target.value)} />
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Cancel</button>
        <button onClick={save} disabled={busy} style={btn()}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
    </Modal>
  );
}

function EntryModal({ spaceId, kind, entry, cats, onClose, onSaved }) {
  const [catId, setCatId] = useState(entry.category_id || (cats[0] && cats[0].id) || '');
  const [date, setDate] = useState(entry.entry_date ? String(entry.entry_date).slice(0, 10) : new Date().toISOString().slice(0, 10));
  const [desc, setDesc] = useState(entry.description || '');
  const [ref, setRef] = useState(entry.reference_no || '');
  const [amount, setAmount] = useState(entry.amount ?? '');
  const [busy, setBusy] = useState(false);
  const base = `/projects/${spaceId}/${kind}/entries`;
  const today = new Date().toISOString().slice(0, 10);
  const save = async () => {
    if (!catId || !date) return;
    if (date > today) { alert('Entry date cannot be in the future.'); return; }
    setBusy(true);
    const payload = { category_id: catId, entry_date: date, description: desc, reference_no: ref, amount };
    try {
      if (entry.id) await financialApi.put(`${base}/${entry.id}`, payload);
      else await financialApi.post(base, payload);
      onSaved();
    } catch (e) { alert(e.error || 'Failed'); setBusy(false); }
  };
  return (
    <Modal title={entry.id ? 'Edit Entry' : 'New Entry'} onClose={onClose}>
      <label style={lbl}>Category</label>
      <select style={inp} value={catId} onChange={e => setCatId(e.target.value)}>
        {cats.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
        <div style={{ flex: 1 }}><label style={lbl}>Entry date</label><input style={inp} type="date" max={today} value={date} onChange={e => setDate(e.target.value)} /></div>
        <div style={{ flex: 1 }}><label style={lbl}>Amount</label><input style={inp} type="number" value={amount} onChange={e => setAmount(e.target.value)} /></div>
      </div>
      <label style={{ ...lbl, marginTop: 12 }}>Description</label>
      <input style={inp} value={desc} onChange={e => setDesc(e.target.value)} />
      <label style={{ ...lbl, marginTop: 12 }}>Reference number</label>
      <input style={inp} value={ref} onChange={e => setRef(e.target.value)} />
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Cancel</button>
        <button onClick={save} disabled={busy} style={btn()}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
    </Modal>
  );
}

// ══════════════════════════════ OPEX ══════════════════════════════
function OpexSection({ spaceId, year, month, canManage = true }) {
  const KIND = 'opex';
  const planYear = year === 'all' ? new Date().getFullYear() : year;
  const [budgets, setBudgets] = useState([]);
  const [entries, setEntries] = useState([]);
  const [planBaseline, setPlanBaseline] = useState([]);
  const [planRolling, setPlanRolling] = useState([]);
  const [baseState, setBaseState] = useState({ status: 'draft' });
  const [actualGrid, setActualGrid] = useState({});
  const [dash, setDash] = useState(null);
  const [view, setView] = useState('dashboard');
  const [planType, setPlanType] = useState('baseline');
  const [budModal, setBudModal] = useState(null);
  const [entryModal, setEntryModal] = useState(null);
  const [planCat, setPlanCat] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [copyMsg, setCopyMsg] = useState('');

  const load = useCallback(() => {
    financialApi.get(`/projects/${spaceId}/opex/budgets`).then(setBudgets).catch(() => {});
    financialApi.get(`/projects/${spaceId}/opex/entries`).then(setEntries).catch(() => {});
    financialApi.get(`/projects/${spaceId}/opex/plan?plan_type=baseline`).then(setPlanBaseline).catch(() => {});
    financialApi.get(`/projects/${spaceId}/opex/plan?plan_type=rolling`).then(setPlanRolling).catch(() => {});
    financialApi.get(`/projects/${spaceId}/opex/baseline-state`).then(setBaseState).catch(() => {});
    financialApi.get(`/projects/${spaceId}/opex/actual-expenditure?year=${planYear}`).then(r => setActualGrid(r.grid || {})).catch(() => {});
    financialApi.get(`/projects/${spaceId}/opex/dashboard?year=${year}&month=${month}`).then(setDash).catch(() => {});
  }, [spaceId, year, month, planYear]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { const f = () => load(); window.addEventListener('focus', f); const t = setInterval(load, 20000); return () => { window.removeEventListener('focus', f); clearInterval(t); }; }, [load]);

  const catName = id => (budgets.find(c => c.id === id) || {}).name || '—';
  const plan = planType === 'baseline' ? planBaseline : planRolling;
  const baselineApproved = baseState.status === 'approved';

  return (
    <div>
      <div style={{ display: 'flex', gap: 4, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['dashboard', 'Dashboard'], ['budgets', 'Annual Budgets'], ['plan', 'Monthly Budget Plan'], ['actual', 'Actual Expenditure'], ['entries', 'Expense Entries']].map(([k, l]) => (
          <button key={k} onClick={() => setView(k)} style={{ ...btn(view === k ? '#EEF2FF' : '#fff', view === k ? '#4F46E5' : '#6B7280'), borderColor: '#E5E7EB' }}>{l}</button>
        ))}
      </div>
      {copyMsg && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#EEF2FF', border: '1px solid #C7D2FE', color: '#3730A3', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>
          <span style={{ flex: 1 }}>{copyMsg}</span>
          <button onClick={() => setCopyMsg('')} style={{ ...btn('#fff', '#4F46E5'), borderColor: '#C7D2FE', padding: '4px 10px', fontSize: 12 }}>Dismiss</button>
        </div>
      )}



      {view === 'dashboard' && dash && (
        <div style={card}>
          <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 0 }}>OPEX Performance — {dash.year === 'all' ? 'All years' : `FY ${dash.year}`}{dash.up_to_month && year !== 'all' ? ` (through ${MONTHS[dash.up_to_month - 1]})` : ''}</h3>
          <p style={{ fontSize: 11.5, color: '#9CA3AF', marginTop: 0, marginBottom: 12 }}>Actuals from expenditure entries; YTD Budget from the Rolling monthly budget plan; cumulative to the selected month.</p>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr>
                <th style={th}>Description</th><th style={{ ...th, textAlign: 'right' }}>Annual Budget</th>
                <th style={{ ...th, textAlign: 'right' }}>Total Budget<br /><span style={{ fontWeight: 400, fontSize: 10, color: '#9CA3AF' }}>(all years)</span></th>
                <th style={{ ...th, textAlign: 'right' }}>ITD Actual</th><th style={{ ...th, textAlign: 'right' }}>Remaining</th><th style={{ ...th, textAlign: 'right' }}>YTD Actual</th>
                <th style={{ ...th, textAlign: 'right' }}>YTD Budget</th><th style={{ ...th, textAlign: 'right' }}>Variance</th><th style={{ ...th, textAlign: 'right' }}>Variance %</th>
              </tr></thead>
              <tbody>
                {dash.rows.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={9}>No OPEX categories yet.</td></tr>}
                {dash.rows.map(r => (
                  <tr key={r.id}>
                    <td style={{ ...td, fontWeight: 600 }}>{r.name}</td>
                    <td style={{ ...td, textAlign: 'right' }}>{nf(r.annual_budget)}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 700 }}>{nf(r.total_budget)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>{nf(r.itd_actual)}</td>
                    <td style={{ ...td, textAlign: 'right', color: r.remaining < 0 ? '#DC2626' : '#111827' }}>{nf(r.remaining)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>{nf(r.ytd_actual)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>{nf(r.ytd_budget)}</td>
                    <td style={{ ...td, textAlign: 'right', color: varColor(r.variance) }}>{r.variance >= 0 ? '+' : ''}{nf(r.variance)}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: varColor(r.variance_pct) }}>{r.variance_pct >= 0 ? '+' : ''}{nf(r.variance_pct)}%</td>
                  </tr>
                ))}
              </tbody>
              {dash.rows.length > 0 && <tfoot><tr style={{ background: '#F9FAFB', fontWeight: 800 }}>
                <td style={{ ...td, fontWeight: 800 }}>Total OPEX</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.annual_budget)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.total_budget)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.itd_actual)}</td>
                <td style={{ ...td, textAlign: 'right', color: dash.totals.remaining < 0 ? '#DC2626' : '#111827' }}>{nf(dash.totals.remaining)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.ytd_actual)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(dash.totals.ytd_budget)}</td>
                <td style={{ ...td, textAlign: 'right', color: varColor(dash.totals.variance) }}>{dash.totals.variance >= 0 ? '+' : ''}{nf(dash.totals.variance)}</td>
                <td style={{ ...td, textAlign: 'right', color: varColor(dash.totals.variance_pct) }}>{dash.totals.variance_pct >= 0 ? '+' : ''}{nf(dash.totals.variance_pct)}%</td>
              </tr></tfoot>}
            </table>
          </div>
        </div>
      )}

      {view === 'budgets' && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
            <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, flex: 1 }}>OPEX Budget Categories</h3>
            {canManage && <button onClick={() => setBudModal({})} style={btn()}>+ Add Category</button>}
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Description</th><th style={{ ...th, textAlign: 'right' }}>Annual Budget</th><th style={th}>Notes</th><th style={th}>Last modified</th><th style={th}></th></tr></thead>
            <tbody>
              {budgets.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={5}>No budgets yet.</td></tr>}
              {budgets.map(c => {
                const drow = dash && dash.rows.find(r => r.id === c.id);
                return (
                <tr key={c.id}>
                  <td style={{ ...td, fontWeight: 600 }}>{c.name}</td>
                  <td style={{ ...td, textAlign: 'right' }} title="From the Baseline monthly budget plan">{drow ? nf(drow.annual_budget) : '—'}</td>
                  <td style={{ ...td, color: '#6B7280' }}>{c.notes || '—'}</td>
                  <td style={{ ...td, color: '#9CA3AF', fontSize: 11 }}>{c.modified_by_name || c.created_by_name || '—'}<br />{fmtDateTime(c.modified_at || c.created_at)}</td>
                  <td style={{ ...td, textAlign: 'right' }}>
                    {canManage ? <>
                    <button onClick={() => setBudModal(c)} style={{ ...btn('#F3F4F6', '#374151'), padding: '5px 10px', marginRight: 6 }}>Edit</button>
                    <button onClick={() => setConfirm({ title: 'Delete budget', message: 'Delete this OPEX budget and its expense entries? This cannot be undone.', run: async () => { await financialApi.delete(`/projects/${spaceId}/opex/budgets/${c.id}`); setConfirm(null); load(); } })} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '5px 10px', borderColor: '#FECACA' }}>Delete</button>
                    </> : <span style={{ color: '#D1D5DB', fontSize: 12 }}>—</span>}
                  </td>
                </tr>
                );
              })}
            </tbody>
          </table>
          <div style={{ fontSize: 11.5, color: '#9CA3AF', marginTop: 10 }}>Annual Budget is the sum of each category's Baseline monthly budget plan. Set it under Monthly Budget Plan → Baseline.</div>
        </div>
      )}

      {view === 'plan' && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
            <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0 }}>Monthly Budget Plan — FY {planYear}</h3>
            <div style={{ display: 'flex', gap: 4, marginLeft: 'auto' }}>
              <button onClick={() => setPlanType('baseline')} style={{ ...btn(planType === 'baseline' ? '#EEF2FF' : '#fff', planType === 'baseline' ? '#4F46E5' : '#6B7280'), borderColor: '#E5E7EB', padding: '6px 12px' }}>Baseline</button>
              <button onClick={() => setPlanType('rolling')} style={{ ...btn(planType === 'rolling' ? '#EEF2FF' : '#fff', planType === 'rolling' ? '#4F46E5' : '#6B7280'), borderColor: '#E5E7EB', padding: '6px 12px' }}>Rolling</button>
            </div>
          </div>
          {planType === 'baseline' && <BaselineBanner spaceId={spaceId} kind={KIND} year={planYear} state={baseState} onChange={load} canManage={canManage} />}
          {planType === 'rolling' && (
            <div style={{ marginBottom: 10 }}>
              <button onClick={() => setConfirm({ title: 'Copy from Baseline', message: `Copy the Baseline plan into the Rolling plan for FY ${planYear}? This overwrites the rolling cells for this year.`, confirmLabel: 'Copy', danger: false, run: async () => { try { await financialApi.post(`/projects/${spaceId}/${KIND}/plan/copy-baseline-to-rolling`, { fin_year: planYear }); setConfirm(null); setCopyMsg(`Baseline copied into the rolling plan for FY ${planYear}.`); load(); } catch (e) { setConfirm(null); setCopyMsg(e.error || 'Copy failed.'); } } })} style={{ ...btn('#4F46E5'), padding: '6px 14px', fontSize: 12.5 }}>⧉ Copy from Baseline</button>
              <span style={{ fontSize: 11.5, color: '#9CA3AF', marginLeft: 10 }}>Pulls the baseline figures into rolling so you can adjust them — available even before the baseline is approved.</span>
            </div>
          )}
          <p style={{ fontSize: 12, color: '#6B7280', marginTop: 0 }}>
            {planType === 'baseline' ? 'The approved baseline is the fixed comparison basis for variance. ' : 'The rolling plan is your working forecast and can change anytime. '}
            Click a cell to edit. Used to compute YTD Budget.
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
              <thead><tr><th style={th}>Category</th>{MONTHS.map(m => <th key={m} style={{ ...th, textAlign: 'right' }}>{m}</th>)}<th style={{ ...th, textAlign: 'right' }}>Total</th></tr></thead>
              <tbody>
                {budgets.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={14}>Add budgets first.</td></tr>}
                {budgets.map(c => {
                  const rowTotal = plan.filter(p => p.category_id === c.id && p.fin_year === planYear).reduce((s, p) => s + Number(p.planned_budget || 0), 0);
                  return (
                    <tr key={c.id}>
                      <td style={{ ...td, fontWeight: 600, position: 'sticky', left: 0, background: '#fff' }}>{c.name}</td>
                      {MONTHS.map((m, i) => {
                        const cell = plan.find(p => p.category_id === c.id && p.fin_year === planYear && p.month === i + 1);
                        const editable = planType === 'rolling' ? true : (canManage && !baselineApproved);
                        return (
                          <td key={i} style={{ ...td, textAlign: 'right', cursor: editable ? 'pointer' : 'default', color: cell ? '#111827' : '#D1D5DB' }}
                            onClick={() => editable && setPlanCat({ category_id: c.id, name: c.name, month: i + 1, plan_type: planType, planned_budget: cell ? cell.planned_budget : '' })}>
                            {cell ? nf(cell.planned_budget) : '–'}
                          </td>
                        );
                      })}
                      <td style={{ ...td, textAlign: 'right', fontWeight: 700 }}>{nf(rowTotal)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {view === 'actual' && (
        <div style={card}>
          <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 0 }}>Actual Expenditure — FY {planYear}</h3>
          <p style={{ fontSize: 12, color: '#6B7280', marginTop: 0 }}>Built automatically from expense entries, per category and month. Add entries under "Expense Entries".</p>
          <div style={{ marginBottom: 10 }}>
            <button onClick={() => setConfirm({ title: 'Copy from Baseline', message: `Create actual expenditure entries from the Baseline plan for FY ${planYear}? Existing baseline-copied entries for this year are replaced; you can then edit them under Expense Entries.`, confirmLabel: 'Copy', danger: false, run: async () => { try { const r = await financialApi.post(`/projects/${spaceId}/${KIND}/copy-baseline-to-actual`, { fin_year: planYear }); setConfirm(null); setCopyMsg(`Created ${r.created} entries from baseline. Edit them under Expense Entries.`); load(); } catch (e) { setConfirm(null); setCopyMsg(e.error || 'Copy failed.'); } } })} style={{ ...btn('#4F46E5'), padding: '6px 14px', fontSize: 12.5 }}>⧉ Copy from Baseline</button>
            <span style={{ fontSize: 11.5, color: '#9CA3AF', marginLeft: 10 }}>Generates editable actual entries (dated mid-month) from the baseline, then adjust them under Expense Entries.</span>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
              <thead><tr><th style={th}>Category</th>{MONTHS.map(m => <th key={m} style={{ ...th, textAlign: 'right' }}>{m}</th>)}<th style={{ ...th, textAlign: 'right' }}>Total</th></tr></thead>
              <tbody>
                {budgets.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={14}>No categories yet.</td></tr>}
                {budgets.map(c => {
                  const row = actualGrid[c.id] || {};
                  const rowTotal = Object.values(row).reduce((s, v) => s + Number(v || 0), 0);
                  return (
                    <tr key={c.id}>
                      <td style={{ ...td, fontWeight: 600, position: 'sticky', left: 0, background: '#fff' }}>{c.name}</td>
                      {MONTHS.map((m, i) => <td key={i} style={{ ...td, textAlign: 'right', color: row[i + 1] ? '#111827' : '#D1D5DB' }}>{row[i + 1] ? nf(row[i + 1]) : '–'}</td>)}
                      <td style={{ ...td, textAlign: 'right', fontWeight: 700 }}>{nf(rowTotal)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {view === 'entries' && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 14 }}>
            <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, flex: 1 }}>OPEX Expense Entries</h3>
            <button onClick={() => setEntryModal({})} style={btn()} disabled={budgets.length === 0}>+ Add Expense</button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Date</th><th style={th}>Category</th><th style={th}>Description</th><th style={th}>Reference</th><th style={{ ...th, textAlign: 'right' }}>Amount</th><th style={th}>Entered by</th><th style={th}></th></tr></thead>
            <tbody>
              {(() => {
                const list = year === 'all' ? entries : entries.filter(e => { const d = new Date(e.entry_date); return d.getUTCFullYear() === planYear && (d.getUTCMonth() + 1) <= month; });
                if (list.length === 0) return <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={7}>No expenses in this period.</td></tr>;
                return list.map(e => (
                  <tr key={e.id}>
                    <td style={td}>{fmtDate(e.entry_date)}</td>
                    <td style={{ ...td, fontWeight: 600 }}>{catName(e.category_id)}</td>
                    <td style={td}>{e.description || '—'}</td>
                    <td style={{ ...td, color: '#6B7280' }}>{e.reference_no || '—'}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{nf(e.amount)}</td>
                    <td style={{ ...td, color: '#9CA3AF', fontSize: 11 }}>{e.created_by_name || '—'}<br />{fmtDateTime(e.created_at)}</td>
                    <td style={{ ...td, textAlign: 'right' }}>
                      <button onClick={() => setEntryModal(e)} style={{ ...btn('#F3F4F6', '#374151'), padding: '5px 10px', marginRight: 6 }}>Edit</button>
                      <button onClick={() => setConfirm({ title: 'Delete expense', message: 'Delete this expense entry? This cannot be undone.', run: async () => { await financialApi.delete(`/projects/${spaceId}/opex/entries/${e.id}`); setConfirm(null); load(); } })} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '5px 10px', borderColor: '#FECACA' }}>Delete</button>
                    </td>
                  </tr>
                ));
              })()}
            </tbody>
          </table>
        </div>
      )}

      {budModal && <BudgetModal spaceId={spaceId} bud={budModal} onClose={() => setBudModal(null)} onSaved={() => { setBudModal(null); load(); }} />}
      {entryModal && <EntryModal spaceId={spaceId} kind="opex" entry={entryModal} cats={budgets} onClose={() => setEntryModal(null)} onSaved={() => { setEntryModal(null); load(); }} />}
      {planCat && <PlanModal spaceId={spaceId} kind="opex" year={planYear} data={planCat} onClose={() => setPlanCat(null)} onSaved={() => { setPlanCat(null); load(); }} />}
      {confirm && <ConfirmModal title={confirm.title} message={confirm.message} confirmLabel={confirm.confirmLabel || 'Confirm'} danger={confirm.danger !== false ? confirm.danger : false} onConfirm={confirm.run} onClose={() => setConfirm(null)} />}
    </div>
  );
}

function BudgetModal({ spaceId, bud, onClose, onSaved }) {
  const [name, setName] = useState(bud.name || '');
  const [notes, setNotes] = useState(bud.notes || '');
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!name.trim()) return; setBusy(true);
    try {
      if (bud.id) await financialApi.put(`/projects/${spaceId}/opex/budgets/${bud.id}`, { name, notes });
      else await financialApi.post(`/projects/${spaceId}/opex/budgets`, { name, notes });
      onSaved();
    } catch (e) { alert(e.error || 'Failed'); setBusy(false); }
  };
  return (
    <Modal title={bud.id ? 'Edit Category' : 'New OPEX Category'} onClose={onClose}>
      <label style={lbl}>Description</label>
      <input style={inp} value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Manpower" />
      <label style={{ ...lbl, marginTop: 12 }}>Notes</label>
      <textarea style={{ ...inp, minHeight: 60 }} value={notes} onChange={e => setNotes(e.target.value)} />
      <div style={{ fontSize: 11.5, color: '#9CA3AF', marginTop: 10 }}>The Annual Budget is calculated automatically from this category's Baseline monthly budget plan.</div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Cancel</button>
        <button onClick={save} disabled={busy} style={btn()}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
    </Modal>
  );
}

function AuditSection({ spaceId }) {
  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [fEntity, setFEntity] = useState('');
  const [fAction, setFAction] = useState('');
  const [fUser, setFUser] = useState('');
  const [fFrom, setFFrom] = useState('');
  const [fTo, setFTo] = useState('');
  const load = useCallback(() => {
    const qs = new URLSearchParams();
    if (fEntity) qs.set('entity', fEntity);
    if (fAction) qs.set('action', fAction);
    if (fUser) qs.set('user_id', fUser);
    if (fFrom) qs.set('from', fFrom);
    if (fTo) qs.set('to', fTo);
    financialApi.get(`/projects/${spaceId}/audit?${qs.toString()}`).then(setData).catch(() => setData({ rows: [], entities: [], actions: [] }));
  }, [spaceId, fEntity, fAction, fUser, fFrom, fTo]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { financialApi.get(`/projects/${spaceId}/users`).then(setUsers).catch(() => {}); }, [spaceId]);
  useEffect(() => { const f = () => load(); window.addEventListener('focus', f); const t = setInterval(load, 20000); return () => { window.removeEventListener('focus', f); clearInterval(t); }; }, [load]);
  const clear = () => { setFEntity(''); setFAction(''); setFUser(''); setFFrom(''); setFTo(''); };
  if (data === null) return <div style={{ color: '#6B7280' }}>Loading…</div>;
  const rows = data.rows || [];
  const active = fEntity || fAction || fUser || fFrom || fTo;
  const sel = { ...inp, width: 'auto', padding: '6px 9px', fontSize: 12 };
  return (
    <div style={card}>
      <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 0 }}>Audit Trail</h3>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 14, padding: '10px 12px', background: '#F8FAFC', border: '1px solid #E5E7EB', borderRadius: 10 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: '#6B7280' }}>🔎 Filter:</span>
        <select value={fEntity} onChange={e => setFEntity(e.target.value)} style={sel}>
          <option value="">All items</option>
          {(data.entities || []).map(x => <option key={x} value={x}>{x.replace(/_/g, ' ')}</option>)}
        </select>
        <select value={fAction} onChange={e => setFAction(e.target.value)} style={sel}>
          <option value="">All actions</option>
          {(data.actions || []).map(x => <option key={x} value={x}>{x}</option>)}
        </select>
        <select value={fUser} onChange={e => setFUser(e.target.value)} style={sel}>
          <option value="">All users</option>
          {users.map(u => <option key={u.id} value={u.id}>{u.full_name}</option>)}
        </select>
        <span style={{ fontSize: 12, color: '#9CA3AF' }}>From</span>
        <input type="date" value={fFrom} onChange={e => setFFrom(e.target.value)} style={sel} />
        <span style={{ fontSize: 12, color: '#9CA3AF' }}>to</span>
        <input type="date" value={fTo} onChange={e => setFTo(e.target.value)} style={sel} />
        {active && <button onClick={clear} style={{ ...btn('#F3F4F6', '#374151'), padding: '6px 12px' }}>Clear</button>}
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead><tr><th style={th}>When</th><th style={th}>User</th><th style={th}>Action</th><th style={th}>Item</th><th style={th}>Detail</th></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={5}>{active ? 'No activity matches the filters.' : 'No activity yet.'}</td></tr>}
          {rows.map(r => (
            <tr key={r.id}>
              <td style={{ ...td, color: '#6B7280', whiteSpace: 'nowrap' }}>{fmtDateTime(r.created_at)}</td>
              <td style={{ ...td, fontWeight: 600 }}>{r.user_name || '—'}</td>
              <td style={td}><span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 99, background: '#EEF2FF', color: '#4F46E5' }}>{r.action}</span></td>
              <td style={{ ...td, color: '#6B7280' }}>{r.entity.replace(/_/g, ' ')}</td>
              <td style={{ ...td, color: '#6B7280' }}>{r.detail || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ══════════════════════════════ ROLES ══════════════════════════════
function RolesSection({ spaceId }) {
  const [pms, setPms] = useState([]);
  const [assignable, setAssignable] = useState([]);
  const [sel, setSel] = useState('');
  const [role, setRole] = useState('manager');
  const [confirm, setConfirm] = useState(null);
  const [copyMsg, setCopyMsg] = useState('');
  const load = useCallback(() => {
    financialApi.get(`/projects/${spaceId}/financial-pms`).then(setPms).catch(() => {});
    financialApi.get(`/projects/${spaceId}/assignable-users`).then(setAssignable).catch(() => {});
  }, [spaceId]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { const f = () => load(); window.addEventListener('focus', f); const t = setInterval(load, 20000); return () => { window.removeEventListener('focus', f); clearInterval(t); }; }, [load]);
  const add = async () => { if (!sel) return; await financialApi.post(`/projects/${spaceId}/financial-pms`, { user_id: sel, role }); setSel(''); setRole('manager'); load(); };
  const changeRole = async (uid, newRole) => { await financialApi.post(`/projects/${spaceId}/financial-pms`, { user_id: uid, role: newRole }); load(); };
  const remove = (uid, name) => setConfirm({ title: 'Remove Financial PM', message: `Remove ${name || 'this person'} as a Financial Project Manager? They will lose access to this tab.`, confirmLabel: 'Remove', run: async () => { await financialApi.delete(`/projects/${spaceId}/financial-pms/${uid}`); setConfirm(null); load(); } });
  const free = assignable.filter(u => !pms.find(p => p.user_id === u.id));
  const RoleBadge = ({ r }) => <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 9px', borderRadius: 99, background: r === 'manager' ? '#EEF2FF' : '#F1F5F9', color: r === 'manager' ? '#4F46E5' : '#475569' }}>{r === 'manager' ? 'Manager' : 'Member'}</span>;
  return (
    <div style={card}>
      <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 0 }}>Financial Project Managers</h3>
      <p style={{ fontSize: 12.5, color: '#6B7280', marginTop: 0 }}>Only the project creator and project managers can assign these. <b>Manager</b> can do everything including configuring &amp; approving the Baseline. <b>Member</b> can only edit the Rolling plan and record Expenditure / Expense entries.</p>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        <select style={{ ...inp, flex: 1, minWidth: 200 }} value={sel} onChange={e => setSel(e.target.value)}>
          <option value="">Select a project member…</option>
          {free.map(u => <option key={u.id} value={u.id}>{u.full_name}{u.email ? ` (${u.email})` : ''}</option>)}
        </select>
        <select style={{ ...inp, width: 'auto' }} value={role} onChange={e => setRole(e.target.value)}>
          <option value="manager">Manager</option>
          <option value="member">Member</option>
        </select>
        <button onClick={add} disabled={!sel} style={btn()}>Assign</button>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead><tr><th style={th}>Name</th><th style={th}>Email</th><th style={th}>Role</th><th style={th}></th></tr></thead>
        <tbody>
          {pms.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={4}>No Financial PMs assigned yet.</td></tr>}
          {pms.map(p => (
            <tr key={p.user_id}>
              <td style={{ ...td, fontWeight: 600 }}>{p.full_name}</td>
              <td style={{ ...td, color: '#6B7280' }}>{p.email || '—'}</td>
              <td style={td}>
                <select value={p.role || 'manager'} onChange={e => changeRole(p.user_id, e.target.value)} style={{ ...inp, width: 'auto', padding: '4px 8px', fontSize: 12 }}>
                  <option value="manager">Manager</option>
                  <option value="member">Member</option>
                </select>
              </td>
              <td style={{ ...td, textAlign: 'right' }}><button onClick={() => remove(p.user_id, p.full_name)} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '5px 10px', borderColor: '#FECACA' }}>Remove</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {confirm && <ConfirmModal title={confirm.title} message={confirm.message} confirmLabel={confirm.confirmLabel} onConfirm={confirm.run} onClose={() => setConfirm(null)} />}
    </div>
  );
}

// ══════════════════════════════ FUNDING STATUS ══════════════════════════════
function FundingSection({ spaceId }) {
  const [rows, setRows] = useState([]);
  const [cats, setCats] = useState([]);
  const [modal, setModal] = useState(null);
  const [catModal, setCatModal] = useState(false);
  const [confirm, setConfirm] = useState(null);
  const [copyMsg, setCopyMsg] = useState('');
  const load = useCallback(() => {
    financialApi.get(`/projects/${spaceId}/funding`).then(setRows).catch(() => {});
    financialApi.get(`/projects/${spaceId}/funding-categories`).then(setCats).catch(() => {});
  }, [spaceId]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { const f = () => load(); window.addEventListener('focus', f); const t = setInterval(load, 20000); return () => { window.removeEventListener('focus', f); clearInterval(t); }; }, [load]);
  return (
    <div style={card}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6, gap: 8 }}>
        <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, flex: 1 }}>Funding Status</h3>
        <button onClick={() => setCatModal(true)} style={btn('#F3F4F6', '#374151')}>+ Add Category</button>
        <button onClick={() => setModal({})} style={btn()}>+ Add Item</button>
      </div>
      <p style={{ fontSize: 12, color: '#6B7280', marginTop: 0 }}>Snapshot of funding sources, releases and gaps for executive reporting.</p>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead><tr><th style={th}>Item</th><th style={th}>Category</th><th style={{ ...th, textAlign: 'right' }}>Amount</th><th style={th}>Progress</th><th style={th}>Due / Expected</th><th style={th}>Notes</th><th style={th}></th></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={7}>No funding items yet.</td></tr>}
          {rows.map(r => (
            <tr key={r.id}>
              <td style={{ ...td, fontWeight: 600 }}>{(r.is_major === 1 || r.is_major === true) && <span title="Major" style={{ marginRight: 4 }}>⭐</span>}{r.item}</td>
              <td style={{ ...td, color: '#6B7280' }}>{r.category || '—'}</td>
              <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{nf(r.amount)}{r.is_text && r.text_value ? <span style={{ color: '#6B7280', fontWeight: 400 }}> · {r.text_value}</span> : ''}</td>
              <td style={td}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <div style={{ flex: 1, minWidth: 70, height: 7, background: '#F1F5F9', borderRadius: 4, overflow: 'hidden' }}>
                    <div style={{ width: `${Math.max(0, Math.min(100, Number(r.progress) || 0))}%`, height: '100%', background: '#4F46E5' }} />
                  </div>
                  <span style={{ fontSize: 11, color: '#6B7280', minWidth: 30 }}>{Math.round(Number(r.progress) || 0)}%</span>
                </div>
              </td>
              <td style={td}>{r.due_date ? fmtDate(r.due_date) : '—'}</td>
              <td style={{ ...td, color: '#6B7280', whiteSpace: 'pre-wrap' }}>{r.notes || '—'}</td>
              <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>
                <button onClick={() => setModal(r)} style={{ ...btn('#F3F4F6', '#374151'), padding: '5px 10px', marginRight: 6 }}>Edit</button>
                <button onClick={() => setConfirm({ run: async () => { await financialApi.delete(`/projects/${spaceId}/funding/${r.id}`); setConfirm(null); load(); } })} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '5px 10px', borderColor: '#FECACA' }}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {modal && <FundingModal spaceId={spaceId} row={modal} cats={cats} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
      {catModal && <FundingCatModal spaceId={spaceId} cats={cats} onClose={() => setCatModal(false)} onSaved={() => load()} />}
      {confirm && <ConfirmModal title="Delete funding item" message="Delete this funding item? This cannot be undone." onConfirm={confirm.run} onClose={() => setConfirm(null)} />}
    </div>
  );
}
function FundingCatModal({ spaceId, cats, onClose, onSaved }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const add = async () => {
    if (!name.trim()) return; setBusy(true);
    try { await financialApi.post(`/projects/${spaceId}/funding-categories`, { name: name.trim() }); setName(''); onSaved(); }
    catch (e) { alert(e.error || 'Failed'); } finally { setBusy(false); }
  };
  return (
    <Modal title="Funding Categories" onClose={onClose} width={420}>
      <p style={{ fontSize: 12.5, color: '#6B7280', marginTop: 0 }}>Create the categories your team uses. They'll appear in the dropdown when adding a funding item.</p>
      <div style={{ display: 'flex', gap: 8 }}>
        <input style={inp} value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Government Grant" onKeyDown={e => { if (e.key === 'Enter') add(); }} />
        <button onClick={add} disabled={busy} style={btn()}>Add</button>
      </div>
      <div style={{ marginTop: 14 }}>
        {cats.length === 0 && <div style={{ fontSize: 12.5, color: '#9CA3AF' }}>No categories yet.</div>}
        {cats.map(c => (
          <div key={c.id} style={{ display: 'flex', alignItems: 'center', padding: '7px 0', borderBottom: '1px solid #F1F3F5' }}>
            <span style={{ fontSize: 13, flex: 1 }}>{c.name}</span>
            <button onClick={async () => { await financialApi.delete(`/projects/${spaceId}/funding-categories/${c.id}`); onSaved(); }} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '4px 9px', borderColor: '#FECACA', fontSize: 12 }}>Remove</button>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Done</button>
      </div>
    </Modal>
  );
}
function FundingModal({ spaceId, row, cats = [], onClose, onSaved }) {
  const [item, setItem] = useState(row.item || '');
  const [category, setCategory] = useState(row.category || '');
  const [isText, setIsText] = useState(row.is_text ? true : false);
  const [amount, setAmount] = useState(row.amount ?? '');
  const [textValue, setTextValue] = useState(row.text_value || '');
  const [dueDate, setDueDate] = useState(row.due_date ? String(row.due_date).slice(0, 10) : '');
  const [notes, setNotes] = useState(row.notes || '');
  const [isMajor, setIsMajor] = useState(row.is_major ? true : false);
  const [progress, setProgress] = useState(row.progress ?? 0);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!item.trim()) return; setBusy(true);
    const payload = { item, category, is_text: isText ? 1 : 0, amount, text_value: textValue, due_date: dueDate || null, notes, is_major: isMajor ? 1 : 0, progress };
    try {
      if (row.id) await financialApi.put(`/projects/${spaceId}/funding/${row.id}`, payload);
      else await financialApi.post(`/projects/${spaceId}/funding`, payload);
      onSaved();
    } catch (e) { alert(e.error || 'Failed'); setBusy(false); }
  };
  return (
    <Modal title={row.id ? 'Edit Funding Item' : 'New Funding Item'} onClose={onClose}>
      <label style={lbl}>Item</label>
      <input style={inp} value={item} onChange={e => setItem(e.target.value)} placeholder="e.g. Government Grant Received to Date" />
      <label style={{ ...lbl, marginTop: 12 }}>Category</label>
      <select style={inp} value={category} onChange={e => setCategory(e.target.value)}>
        <option value="">—</option>
        {cats.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
        {row.category && !cats.find(c => c.name === row.category) && <option value={row.category}>{row.category}</option>}
      </select>
      <label style={{ ...lbl, marginTop: 12 }}>Amount</label>
      <input style={inp} type="number" value={amount} onChange={e => setAmount(e.target.value)} />
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginTop: 12, cursor: 'pointer' }}>
        <input type="checkbox" checked={isText} onChange={e => setIsText(e.target.checked)} />
        Also show a text label (e.g. "Nil", "Secured") alongside the amount
      </label>
      {isText && <><label style={{ ...lbl, marginTop: 12 }}>Text label</label><input style={inp} value={textValue} onChange={e => setTextValue(e.target.value)} placeholder="e.g. Secured" /></>}
      <label style={{ ...lbl, marginTop: 12 }}>Progress ({Math.round(progress)}%)</label>
      <input style={{ width: '100%' }} type="range" min="0" max="100" value={progress} onChange={e => setProgress(parseInt(e.target.value))} />
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginTop: 12, cursor: 'pointer' }}>
        <input type="checkbox" checked={isMajor} onChange={e => setIsMajor(e.target.checked)} />
        <span>⭐ Mark as major — flag this for executive reporting</span>
      </label>
      <label style={{ ...lbl, marginTop: 12 }}>Due / expected date (optional)</label>
      <input style={inp} type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} />
      <label style={{ ...lbl, marginTop: 12 }}>Notes</label>
      <input style={inp} value={notes} onChange={e => setNotes(e.target.value)} />
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Cancel</button>
        <button onClick={save} disabled={busy} style={btn()}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
    </Modal>
  );
}

// ══════════════════════════════ FINANCING UPDATES ══════════════════════════════
const FIN_STATUS = { in_progress: { label: 'In Progress', bg: '#FEF3C7', c: '#B45309' }, secured: { label: 'Secured', bg: '#DCFCE7', c: '#15803D' }, delayed: { label: 'Delayed', bg: '#FEE2E2', c: '#B91C1C' }, completed: { label: 'Completed', bg: '#DBEAFE', c: '#1D4ED8' } };
function FinancingSection({ spaceId }) {
  const [rows, setRows] = useState([]);
  const [modal, setModal] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [copyMsg, setCopyMsg] = useState('');
  const load = useCallback(() => { financialApi.get(`/projects/${spaceId}/financing-updates`).then(setRows).catch(() => {}); }, [spaceId]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { const f = () => load(); window.addEventListener('focus', f); const t = setInterval(load, 20000); return () => { window.removeEventListener('focus', f); clearInterval(t); }; }, [load]);
  return (
    <div style={card}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
        <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, flex: 1 }}>Financing Updates</h3>
        <button onClick={() => setModal({})} style={btn()}>+ Add Update</button>
      </div>
      <p style={{ fontSize: 12, color: '#6B7280', marginTop: 0 }}>Running log of financing progress — narrative, status, amounts and expected dates.</p>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead><tr><th style={th}>Date</th><th style={th}>Title</th><th style={th}>Update</th><th style={th}>Status</th><th style={{ ...th, textAlign: 'right' }}>Amount</th><th style={th}>Expected</th><th style={th}>By</th><th style={th}></th></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={8}>No financing updates yet.</td></tr>}
          {rows.map(r => {
            const st = FIN_STATUS[r.status] || FIN_STATUS.in_progress;
            return (
              <tr key={r.id}>
                <td style={{ ...td, whiteSpace: 'nowrap' }}>{fmtDate(r.update_date)}</td>
                <td style={{ ...td, fontWeight: 600, whiteSpace: 'pre-wrap' }}>{r.title || '—'}</td>
                <td style={{ ...td, maxWidth: 360, whiteSpace: 'pre-wrap' }}>{r.update_text || '—'}</td>
                <td style={td}><span style={{ fontSize: 11, fontWeight: 700, padding: '2px 9px', borderRadius: 99, background: st.bg, color: st.c }}>{st.label}</span></td>
                <td style={{ ...td, textAlign: 'right' }}>{r.amount != null ? nf(r.amount) : '—'}</td>
                <td style={{ ...td, whiteSpace: 'nowrap' }}>{r.expected_date ? fmtDate(r.expected_date) : '—'}</td>
                <td style={{ ...td, color: '#9CA3AF', fontSize: 11 }}>{r.created_by_name || '—'}</td>
                <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button onClick={() => setModal(r)} style={{ ...btn('#F3F4F6', '#374151'), padding: '5px 10px', marginRight: 6 }}>Edit</button>
                  <button onClick={() => setConfirm({ run: async () => { await financialApi.delete(`/projects/${spaceId}/financing-updates/${r.id}`); setConfirm(null); load(); } })} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '5px 10px', borderColor: '#FECACA' }}>Delete</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {modal && <FinancingModal spaceId={spaceId} row={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
      {confirm && <ConfirmModal title="Delete update" message="Delete this financing update? This cannot be undone." onConfirm={confirm.run} onClose={() => setConfirm(null)} />}
    </div>
  );
}
function FinancingModal({ spaceId, row, onClose, onSaved }) {
  const [title, setTitle] = useState(row.title || '');
  const [text, setText] = useState(row.update_text || '');
  const [status, setStatus] = useState(row.status || 'in_progress');
  const [amount, setAmount] = useState(row.amount ?? '');
  const [expected, setExpected] = useState(row.expected_date ? String(row.expected_date).slice(0, 10) : '');
  const [updateDate, setUpdateDate] = useState(row.update_date ? String(row.update_date).slice(0, 10) : new Date().toISOString().slice(0, 10));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!text.trim() && !title.trim()) return; setBusy(true);
    const payload = { title, update_text: text, status, amount, expected_date: expected || null, update_date: updateDate };
    try {
      if (row.id) await financialApi.put(`/projects/${spaceId}/financing-updates/${row.id}`, payload);
      else await financialApi.post(`/projects/${spaceId}/financing-updates`, payload);
      onSaved();
    } catch (e) { alert(e.error || 'Failed'); setBusy(false); }
  };
  return (
    <Modal title={row.id ? 'Edit Financing Update' : 'New Financing Update'} onClose={onClose} width={540}>
      <label style={lbl}>Title</label>
      <input style={inp} value={title} onChange={e => setTitle(e.target.value)} placeholder="e.g. Debt facility negotiation" />
      <label style={{ ...lbl, marginTop: 12 }}>Update</label>
      <textarea style={{ ...inp, minHeight: 90 }} value={text} onChange={e => setText(e.target.value)} placeholder="What happened, next steps, who is involved…" />
      <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
        <div style={{ flex: 1 }}><label style={lbl}>Status</label>
          <select style={inp} value={status} onChange={e => setStatus(e.target.value)}>
            {Object.entries(FIN_STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
          </select></div>
        <div style={{ flex: 1 }}><label style={lbl}>Amount (optional)</label><input style={inp} type="number" value={amount} onChange={e => setAmount(e.target.value)} /></div>
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
        <div style={{ flex: 1 }}><label style={lbl}>Update date</label><input style={inp} type="date" value={updateDate} onChange={e => setUpdateDate(e.target.value)} /></div>
        <div style={{ flex: 1 }}><label style={lbl}>Expected date (optional)</label><input style={inp} type="date" value={expected} onChange={e => setExpected(e.target.value)} /></div>
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Cancel</button>
        <button onClick={save} disabled={busy} style={btn()}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
    </Modal>
  );
}

// ══════════════════════════════ RISK REGISTER ══════════════════════════════
const RISK_STATUS = { green: { label: 'On Track', dot: '#16A34A' }, amber: { label: 'Watch', dot: '#F59E0B' }, red: { label: 'Critical', dot: '#DC2626' }, closed: { label: 'Closed', dot: '#6B7280' } };
const RISK_LEVEL = ['low', 'medium', 'high'];
const levelColor = l => l === 'high' ? '#DC2626' : l === 'medium' ? '#D97706' : '#16A34A';
export function RiskSection({ spaceId, canManage = true }) {
  const [rows, setRows] = useState([]);
  const [users, setUsers] = useState([]);
  const [cats, setCats] = useState([]);
  const [modal, setModal] = useState(null);
  const [catModal, setCatModal] = useState(false);
  const [confirm, setConfirm] = useState(null);
  const [copyMsg, setCopyMsg] = useState('');
  const load = useCallback(() => {
    financialApi.get(`/projects/${spaceId}/risks`).then(setRows).catch(() => {});
    financialApi.get(`/projects/${spaceId}/risk-categories`).then(setCats).catch(() => {});
  }, [spaceId]);
  useEffect(() => { load(); financialApi.get(`/projects/${spaceId}/users`).then(setUsers).catch(() => {}); }, [load, spaceId]);
  useEffect(() => { const f = () => load(); window.addEventListener('focus', f); const t = setInterval(load, 20000); return () => { window.removeEventListener('focus', f); clearInterval(t); }; }, [load]);
  return (
    <div style={card}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6, gap: 8 }}>
        <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, flex: 1 }}>Key Risks &amp; Mitigation</h3>
        {canManage && <button onClick={() => setCatModal(true)} style={btn('#F3F4F6', '#374151')}>+ Add Category</button>}
        {canManage && <button onClick={() => setModal({})} style={btn()}>+ Add Risk</button>}
      </div>
      <p style={{ fontSize: 12, color: '#6B7280', marginTop: 0 }}>Risk register with impact, likelihood, mitigation, owner and RAG status.</p>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
          <thead><tr><th style={th}>Risk</th><th style={th}>Category</th><th style={th}>Impact</th><th style={th}>Likelihood</th><th style={th}>Mitigation</th><th style={th}>Owner</th><th style={th}>Target</th><th style={th}>Status</th><th style={th}></th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={9}>No risks recorded yet.</td></tr>}
            {rows.map(r => {
              const st = RISK_STATUS[r.status] || RISK_STATUS.green;
              return (
                <tr key={r.id}>
                  <td style={{ ...td, fontWeight: 600 }}>{r.risk}</td>
                  <td style={{ ...td, color: '#6B7280' }}>{r.category || '—'}</td>
                  <td style={{ ...td, fontWeight: 600, color: levelColor(r.impact), textTransform: 'capitalize' }}>{r.impact}</td>
                  <td style={{ ...td, color: levelColor(r.likelihood), textTransform: 'capitalize' }}>{r.likelihood}</td>
                  <td style={{ ...td, maxWidth: 280, whiteSpace: 'pre-wrap' }}>{r.mitigation || '—'}</td>
                  <td style={{ ...td, color: '#6B7280' }}>{r.owner || '—'}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{r.target_date ? fmtDate(r.target_date) : '—'}</td>
                  <td style={td}><span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12 }}><span style={{ width: 11, height: 11, borderRadius: '50%', background: st.dot, display: 'inline-block' }} />{st.label}</span></td>
                  <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>
                    {canManage ? <>
                    <button onClick={() => setModal(r)} style={{ ...btn('#F3F4F6', '#374151'), padding: '5px 10px', marginRight: 6 }}>Edit</button>
                    <button onClick={() => setConfirm({ run: async () => { await financialApi.delete(`/projects/${spaceId}/risks/${r.id}`); setConfirm(null); load(); } })} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '5px 10px', borderColor: '#FECACA' }}>Delete</button>
                    </> : <span style={{ color: '#D1D5DB' }}>—</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {modal && <RiskModal spaceId={spaceId} row={modal} users={users} cats={cats} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />}
      {catModal && <RiskCatModal spaceId={spaceId} cats={cats} onClose={() => setCatModal(false)} onSaved={() => load()} />}
      {confirm && <ConfirmModal title="Delete risk" message="Delete this risk? This cannot be undone." onConfirm={confirm.run} onClose={() => setConfirm(null)} />}
    </div>
  );
}
function RiskCatModal({ spaceId, cats, onClose, onSaved }) {
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const add = async () => {
    if (!name.trim()) return; setBusy(true);
    try { await financialApi.post(`/projects/${spaceId}/risk-categories`, { name: name.trim() }); setName(''); onSaved(); }
    catch (e) { alert(e.error || 'Failed'); } finally { setBusy(false); }
  };
  return (
    <Modal title="Risk Categories" onClose={onClose} width={420}>
      <p style={{ fontSize: 12.5, color: '#6B7280', marginTop: 0 }}>Create the risk categories your team uses. They'll appear in the dropdown when adding a risk.</p>
      <div style={{ display: 'flex', gap: 8 }}>
        <input style={inp} value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Financial" onKeyDown={e => { if (e.key === 'Enter') add(); }} />
        <button onClick={add} disabled={busy} style={btn()}>Add</button>
      </div>
      <div style={{ marginTop: 14 }}>
        {cats.length === 0 && <div style={{ fontSize: 12.5, color: '#9CA3AF' }}>No categories yet.</div>}
        {cats.map(c => (
          <div key={c.id} style={{ display: 'flex', alignItems: 'center', padding: '7px 0', borderBottom: '1px solid #F1F3F5' }}>
            <span style={{ fontSize: 13, flex: 1 }}>{c.name}</span>
            <button onClick={async () => { await financialApi.delete(`/projects/${spaceId}/risk-categories/${c.id}`); onSaved(); }} style={{ ...btn('#FEF2F2', '#DC2626'), padding: '4px 9px', borderColor: '#FECACA', fontSize: 12 }}>Remove</button>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Done</button>
      </div>
    </Modal>
  );
}
function RiskModal({ spaceId, row, users = [], cats = [], onClose, onSaved }) {
  const [risk, setRisk] = useState(row.risk || '');
  const [category, setCategory] = useState(row.category || '');
  const [impact, setImpact] = useState(row.impact || 'medium');
  const [likelihood, setLikelihood] = useState(row.likelihood || 'medium');
  const [mitigation, setMitigation] = useState(row.mitigation || '');
  // Owners: multiple project members may be selected, plus an optional free-typed
  // name for people not in the system. We persist all chosen names into the existing
  // `owner` text field (comma-separated) and keep owner_id as the first member id for
  // backward compatibility — no schema change needed.
  const initialOwnerIds = (() => {
    if (Array.isArray(row.owner_ids) && row.owner_ids.length) return row.owner_ids;
    if (row.owner_id) return [row.owner_id];
    // try to recover ids by matching names in the stored text
    if (row.owner) {
      const names = String(row.owner).split(',').map(s => s.trim());
      return users.filter(u => names.includes(u.full_name)).map(u => u.id);
    }
    return [];
  })();
  const initialOther = (() => {
    if (!row.owner) return '';
    const names = String(row.owner).split(',').map(s => s.trim());
    const memberNames = users.map(u => u.full_name);
    const extras = names.filter(n => n && !memberNames.includes(n));
    return extras.join(', ');
  })();
  const [ownerIds, setOwnerIds] = useState(initialOwnerIds);
  const [ownerOther, setOwnerOther] = useState(initialOther);
  const [ownerOpen, setOwnerOpen] = useState(false);
  const [status, setStatus] = useState(row.status || 'green');
  const [targetDate, setTargetDate] = useState(row.target_date ? String(row.target_date).slice(0, 10) : '');
  const [busy, setBusy] = useState(false);
  const toggleOwner = (id) => setOwnerIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const ownerLabel = (() => {
    const names = ownerIds.map(id => (users.find(u => u.id === id) || {}).full_name).filter(Boolean);
    if (ownerOther.trim()) names.push(...ownerOther.split(',').map(s => s.trim()).filter(Boolean));
    return names.length ? names.join(', ') : '— Unassigned —';
  })();
  const save = async () => {
    if (!risk.trim()) return; setBusy(true);
    const memberNames = ownerIds.map(id => (users.find(u => u.id === id) || {}).full_name).filter(Boolean);
    const otherNames = ownerOther.split(',').map(s => s.trim()).filter(Boolean);
    const ownerName = [...memberNames, ...otherNames].join(', ');
    const ownerIdVal = ownerIds[0] || null;
    const payload = { risk, category, impact, likelihood, mitigation, owner: ownerName, owner_id: ownerIdVal, owner_ids: ownerIds, status, target_date: targetDate || null };
    try {
      if (row.id) await financialApi.put(`/projects/${spaceId}/risks/${row.id}`, payload);
      else await financialApi.post(`/projects/${spaceId}/risks`, payload);
      onSaved();
    } catch (e) { alert(e.error || 'Failed'); setBusy(false); }
  };
  return (
    <Modal title={row.id ? 'Edit Risk' : 'New Risk'} onClose={onClose} width={540}>
      <label style={lbl}>Risk</label>
      <input style={inp} value={risk} onChange={e => setRisk(e.target.value)} placeholder="e.g. Financing delay" />
      <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
        <div style={{ flex: 1 }}><label style={lbl}>Category</label>
          <select style={inp} value={category} onChange={e => setCategory(e.target.value)}>
            <option value="">—</option>
            {cats.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
            {category && !cats.find(c => c.name === category) && <option value={category}>{category}</option>}
          </select>
        </div>
        <div style={{ flex: 1, position: 'relative' }}><label style={lbl}>Owner(s)</label>
          <div onClick={() => setOwnerOpen(o => !o)} style={{ ...inp, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6 }}>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: ownerLabel === '— Unassigned —' ? '#9CA3AF' : '#111827' }}>{ownerLabel}</span>
            <span style={{ fontSize: 10, color: '#6B7280' }}>▾</span>
          </div>
          {ownerOpen && (
            <div style={{ position: 'absolute', zIndex: 30, top: '100%', left: 0, right: 0, marginTop: 4, background: '#fff', border: '1px solid #E5E7EB', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', maxHeight: 220, overflowY: 'auto', padding: 6 }}>
              {users.length === 0 && <div style={{ fontSize: 12, color: '#9CA3AF', padding: '6px 8px' }}>No project members</div>}
              {users.map(u => (
                <label key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}
                  onMouseEnter={e => e.currentTarget.style.background = '#F3F4F6'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <input type="checkbox" checked={ownerIds.includes(u.id)} onChange={() => toggleOwner(u.id)} />
                  <span>{u.full_name}</span>
                </label>
              ))}
              <div style={{ borderTop: '1px solid #F3F4F6', marginTop: 6, paddingTop: 8 }}>
                <div style={{ fontSize: 10.5, color: '#9CA3AF', padding: '0 8px 4px', textTransform: 'uppercase', letterSpacing: '.5px' }}>Other (not a member)</div>
                <input style={{ ...inp, margin: '0 4px', width: 'calc(100% - 8px)' }} value={ownerOther} onChange={e => setOwnerOther(e.target.value)} placeholder="Type name(s), comma-separated" onClick={e => e.stopPropagation()} />
              </div>
            </div>
          )}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
        <div style={{ flex: 1 }}><label style={lbl}>Impact</label>
          <select style={inp} value={impact} onChange={e => setImpact(e.target.value)}>{RISK_LEVEL.map(l => <option key={l} value={l} style={{ textTransform: 'capitalize' }}>{l}</option>)}</select></div>
        <div style={{ flex: 1 }}><label style={lbl}>Likelihood</label>
          <select style={inp} value={likelihood} onChange={e => setLikelihood(e.target.value)}>{RISK_LEVEL.map(l => <option key={l} value={l}>{l}</option>)}</select></div>
        <div style={{ flex: 1 }}><label style={lbl}>Status</label>
          <select style={inp} value={status} onChange={e => setStatus(e.target.value)}>{Object.entries(RISK_STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}</select></div>
      </div>
      <label style={{ ...lbl, marginTop: 12 }}>Mitigation</label>
      <textarea style={{ ...inp, minHeight: 70 }} value={mitigation} onChange={e => setMitigation(e.target.value)} placeholder="Mitigation actions…" />
      <label style={{ ...lbl, marginTop: 12 }}>Target date (optional)</label>
      <input style={inp} type="date" value={targetDate} onChange={e => setTargetDate(e.target.value)} />
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button onClick={onClose} style={btn('#F3F4F6', '#374151')}>Cancel</button>
        <button onClick={save} disabled={busy} style={btn()}>{busy ? 'Saving…' : 'Save'}</button>
      </div>
    </Modal>
  );
}

// ══════════════════════════════ OVERVIEW ══════════════════════════════
function OverviewSection({ spaceId, year, month }) {
  const [data, setData] = useState(null);
  const [funding, setFunding] = useState([]);
  const [risks, setRisks] = useState([]);
  const load = useCallback(() => {
    financialApi.get(`/projects/${spaceId}/overview?year=${year}&month=${month}`).then(setData).catch(() => setData(null));
    financialApi.get(`/projects/${spaceId}/funding`).then(setFunding).catch(() => {});
    financialApi.get(`/projects/${spaceId}/risks`).then(setRisks).catch(() => {});
  }, [spaceId, year, month]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { const f = () => load(); window.addEventListener('focus', f); const t = setInterval(load, 20000); return () => { window.removeEventListener('focus', f); clearInterval(t); }; }, [load]);
  if (!data) return <div style={{ color: '#6B7280', padding: 12 }}>Loading…</div>;

  const Kpi = ({ label, value, accent, sub }) => (
    <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12, padding: 16, flex: 1, minWidth: 160 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '.4px' }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: accent || '#111827', marginTop: 4 }}>{value}</div>
      {sub && <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 2 }}>{sub}</div>}
    </div>
  );
  const c = data.combined;
  const periodLabel = data.year === 'all' ? 'All years' : `FY ${data.year}${data.up_to_month ? ` · through ${MONTHS[data.up_to_month - 1]}` : ''}`;

  // Lightweight dependency-free bar chart: Budget vs YTD Actual per category.
  const BudgetActualChart = ({ accent, block }) => {
    const rows = block.rows.filter(r => r.budget || r.ytd_actual);
    if (rows.length === 0) return <div style={{ fontSize: 12.5, color: '#9CA3AF', padding: '8px 0' }}>No data to chart yet.</div>;
    const max = Math.max(...rows.map(r => Math.max(r.budget, r.ytd_actual)), 1);
    return (
      <div>
        {rows.map(r => (
          <div key={r.id} style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 3 }}>
              <span style={{ fontWeight: 600 }}>{r.name}</span>
              <span style={{ color: '#6B7280' }}>{nf(r.ytd_actual)} / {nf(r.budget)}</span>
            </div>
            <div style={{ position: 'relative', height: 18, background: '#F1F5F9', borderRadius: 5, overflow: 'hidden' }}>
              <div style={{ position: 'absolute', inset: 0, width: `${Math.min(100, (r.budget / max) * 100)}%`, background: '#E5E7EB' }} title={`Budget ${nf(r.budget)}`} />
              <div style={{ position: 'absolute', top: 0, bottom: 0, width: `${Math.min(100, (r.ytd_actual / max) * 100)}%`, background: r.ytd_actual > r.budget ? '#DC2626' : accent, borderRadius: 5 }} title={`Actual ${nf(r.ytd_actual)}`} />
            </div>
          </div>
        ))}
        <div style={{ display: 'flex', gap: 14, fontSize: 11, color: '#6B7280', marginTop: 8 }}>
          <span><span style={{ display: 'inline-block', width: 10, height: 10, background: '#E5E7EB', borderRadius: 2, marginRight: 4 }} />Budget</span>
          <span><span style={{ display: 'inline-block', width: 10, height: 10, background: accent, borderRadius: 2, marginRight: 4 }} />YTD Actual</span>
          <span><span style={{ display: 'inline-block', width: 10, height: 10, background: '#DC2626', borderRadius: 2, marginRight: 4 }} />Over budget</span>
        </div>
      </div>
    );
  };

  // Funding + Risk summaries
  const fundingTotal = funding.filter(f => !f.is_text).reduce((s, f) => s + Number(f.amount || 0), 0);
  const riskCounts = risks.reduce((a, r) => { a[r.status] = (a[r.status] || 0) + 1; return a; }, {});

  const SummaryTable = ({ title, accent, block, budgetLabel }) => (
    <div style={card}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <span style={{ width: 10, height: 10, borderRadius: 3, background: accent, display: 'inline-block' }} />
        <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0 }}>{title}</h3>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>
            <th style={th}>Description</th><th style={{ ...th, textAlign: 'right' }}>{budgetLabel}</th>
            <th style={{ ...th, textAlign: 'right' }}>ITD Actual</th><th style={{ ...th, textAlign: 'right' }}>Remaining</th>
            <th style={{ ...th, textAlign: 'right' }}>YTD Actual</th><th style={{ ...th, textAlign: 'right' }}>YTD Budget</th><th style={{ ...th, textAlign: 'right' }}>Variance %</th>
          </tr></thead>
          <tbody>
            {block.rows.length === 0 && <tr><td style={{ ...td, color: '#9CA3AF', textAlign: 'center' }} colSpan={7}>No categories yet.</td></tr>}
            {block.rows.map(r => (
              <tr key={r.id}>
                <td style={{ ...td, fontWeight: 600 }}>{r.name}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(r.budget)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(r.itd_actual)}</td>
                <td style={{ ...td, textAlign: 'right', color: r.remaining < 0 ? '#DC2626' : '#111827' }}>{nf(r.remaining)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(r.ytd_actual)}</td>
                <td style={{ ...td, textAlign: 'right' }}>{nf(r.ytd_budget)}</td>
                <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: varColor(r.variance_pct) }}>{r.variance_pct >= 0 ? '+' : ''}{nf(r.variance_pct)}%</td>
              </tr>
            ))}
          </tbody>
          {block.rows.length > 0 && <tfoot><tr style={{ background: '#F9FAFB', fontWeight: 800 }}>
            <td style={{ ...td, fontWeight: 800 }}>Total {title}</td>
            <td style={{ ...td, textAlign: 'right' }}>{nf(block.totals.budget)}</td>
            <td style={{ ...td, textAlign: 'right' }}>{nf(block.totals.itd_actual)}</td>
            <td style={{ ...td, textAlign: 'right', color: block.totals.remaining < 0 ? '#DC2626' : '#111827' }}>{nf(block.totals.remaining)}</td>
            <td style={{ ...td, textAlign: 'right' }}>{nf(block.totals.ytd_actual)}</td>
            <td style={{ ...td, textAlign: 'right' }}>{nf(block.totals.ytd_budget)}</td>
            <td style={{ ...td, textAlign: 'right', color: varColor(block.totals.variance_pct) }}>{block.totals.variance_pct >= 0 ? '+' : ''}{nf(block.totals.variance_pct)}%</td>
          </tr></tfoot>}
        </table>
      </div>
    </div>
  );

  return (
    <div>
      <div style={{ fontSize: 12, color: '#6B7280', marginBottom: 12 }}>{periodLabel}</div>
      {/* Combined KPIs */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 18 }}>
        <Kpi label="Total Budget" value={nf(c.budget)} accent="#4F46E5" sub="CAPEX + OPEX" />
        <Kpi label="ITD Actual" value={nf(c.itd_actual)} accent="#0EA5E9" sub="Spent to date" />
        <Kpi label="Remaining" value={nf(c.remaining)} accent={c.remaining < 0 ? '#DC2626' : '#16A34A'} sub="Budget − ITD" />
        <Kpi label="YTD Actual" value={nf(c.ytd_actual)} accent="#0EA5E9" />
        <Kpi label="YTD Budget" value={nf(c.ytd_budget)} accent="#6B7280" />
        <Kpi label="Variance %" value={`${c.variance_pct >= 0 ? '+' : ''}${nf(c.variance_pct)}%`} accent={varColor(c.variance_pct)} sub="YTD Actual vs Budget" />
      </div>

      {/* CAPEX vs OPEX split KPIs */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 18 }}>
        <div style={{ ...card, flex: 1, minWidth: 280, marginBottom: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}><span style={{ width: 10, height: 10, borderRadius: 3, background: '#4F46E5' }} /><h4 style={{ fontSize: 13, fontWeight: 800, margin: 0 }}>CAPEX</h4></div>
          <div style={{ display: 'flex', gap: 16 }}>
            <div><div style={{ fontSize: 11, color: '#6B7280' }}>Budget</div><div style={{ fontSize: 17, fontWeight: 800 }}>{nf(data.capex.totals.budget)}</div></div>
            <div><div style={{ fontSize: 11, color: '#6B7280' }}>ITD Actual</div><div style={{ fontSize: 17, fontWeight: 800 }}>{nf(data.capex.totals.itd_actual)}</div></div>
            <div><div style={{ fontSize: 11, color: '#6B7280' }}>Remaining</div><div style={{ fontSize: 17, fontWeight: 800, color: data.capex.totals.remaining < 0 ? '#DC2626' : '#16A34A' }}>{nf(data.capex.totals.remaining)}</div></div>
            <div><div style={{ fontSize: 11, color: '#6B7280' }}>Variance</div><div style={{ fontSize: 17, fontWeight: 800, color: varColor(data.capex.totals.variance_pct) }}>{data.capex.totals.variance_pct >= 0 ? '+' : ''}{nf(data.capex.totals.variance_pct)}%</div></div>
          </div>
        </div>
        <div style={{ ...card, flex: 1, minWidth: 280, marginBottom: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}><span style={{ width: 10, height: 10, borderRadius: 3, background: '#0EA5E9' }} /><h4 style={{ fontSize: 13, fontWeight: 800, margin: 0 }}>OPEX</h4></div>
          <div style={{ display: 'flex', gap: 16 }}>
            <div><div style={{ fontSize: 11, color: '#6B7280' }}>Budget</div><div style={{ fontSize: 17, fontWeight: 800 }}>{nf(data.opex.totals.budget)}</div></div>
            <div><div style={{ fontSize: 11, color: '#6B7280' }}>ITD Actual</div><div style={{ fontSize: 17, fontWeight: 800 }}>{nf(data.opex.totals.itd_actual)}</div></div>
            <div><div style={{ fontSize: 11, color: '#6B7280' }}>Remaining</div><div style={{ fontSize: 17, fontWeight: 800, color: data.opex.totals.remaining < 0 ? '#DC2626' : '#16A34A' }}>{nf(data.opex.totals.remaining)}</div></div>
            <div><div style={{ fontSize: 11, color: '#6B7280' }}>Variance</div><div style={{ fontSize: 17, fontWeight: 800, color: varColor(data.opex.totals.variance_pct) }}>{data.opex.totals.variance_pct >= 0 ? '+' : ''}{nf(data.opex.totals.variance_pct)}%</div></div>
          </div>
        </div>
      </div>

      {/* Visual charts: Budget vs Actual per category */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 18 }}>
        <div style={{ ...card, flex: 1, minWidth: 320, marginBottom: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}><span style={{ width: 10, height: 10, borderRadius: 3, background: '#4F46E5' }} /><h3 style={{ fontSize: 14, fontWeight: 800, margin: 0 }}>CAPEX — Budget vs Actual</h3></div>
          <BudgetActualChart accent="#4F46E5" block={data.capex} />
        </div>
        <div style={{ ...card, flex: 1, minWidth: 320, marginBottom: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}><span style={{ width: 10, height: 10, borderRadius: 3, background: '#0EA5E9' }} /><h3 style={{ fontSize: 14, fontWeight: 800, margin: 0 }}>OPEX — Budget vs Actual</h3></div>
          <BudgetActualChart accent="#0EA5E9" block={data.opex} />
        </div>
      </div>

      {/* Funding + Risk summaries */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 18 }}>
        <div style={{ ...card, flex: 1, minWidth: 280, marginBottom: 0 }}>
          <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 0 }}>Funding Status</h3>
          {funding.length === 0 ? <div style={{ fontSize: 12.5, color: '#9CA3AF' }}>No funding items recorded.</div> : (
            <>
              <div style={{ display: 'flex', gap: 16, marginBottom: 10 }}>
                <div><div style={{ fontSize: 11, color: '#6B7280' }}>Items</div><div style={{ fontSize: 18, fontWeight: 800 }}>{funding.length}</div></div>
                <div><div style={{ fontSize: 11, color: '#6B7280' }}>Total (numeric)</div><div style={{ fontSize: 18, fontWeight: 800 }}>{nf(fundingTotal)}</div></div>
              </div>
              {funding.slice(0, 5).map(f => (
                <div key={f.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, padding: '4px 0', borderTop: '1px solid #F1F3F5' }}>
                  <span style={{ color: '#374151' }}>{f.item}</span>
                  <span style={{ fontWeight: 600 }}>{f.is_text ? (f.text_value || '—') : nf(f.amount)}</span>
                </div>
              ))}
            </>
          )}
        </div>
        <div style={{ ...card, flex: 1, minWidth: 280, marginBottom: 0 }}>
          <h3 style={{ fontSize: 14, fontWeight: 800, marginTop: 0 }}>Risk Register</h3>
          {risks.length === 0 ? <div style={{ fontSize: 12.5, color: '#9CA3AF' }}>No risks recorded.</div> : (
            <>
              <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
                {[['green', 'On Track', '#16A34A'], ['amber', 'Watch', '#F59E0B'], ['red', 'Critical', '#DC2626']].map(([k, lab, col]) => (
                  <div key={k} style={{ flex: 1, textAlign: 'center', padding: '8px 4px', borderRadius: 8, background: '#F8FAFC', border: '1px solid #E5E7EB' }}>
                    <div style={{ fontSize: 20, fontWeight: 800, color: col }}>{riskCounts[k] || 0}</div>
                    <div style={{ fontSize: 11, color: '#6B7280', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: col, display: 'inline-block' }} />{lab}</div>
                  </div>
                ))}
              </div>
              {risks.slice(0, 5).map(r => (
                <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12.5, padding: '4px 0', borderTop: '1px solid #F1F3F5' }}>
                  <span style={{ color: '#374151' }}>{r.risk}</span>
                  <span style={{ width: 10, height: 10, borderRadius: '50%', background: r.status === 'red' ? '#DC2626' : r.status === 'amber' ? '#F59E0B' : '#16A34A', display: 'inline-block' }} />
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      {/* Secured / completed financing within the selected period */}
      {data.secured_financing && data.secured_financing.length > 0 && (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <h3 style={{ fontSize: 14, fontWeight: 800, margin: 0, flex: 1 }}>Secured / Completed Financing — {periodLabel}</h3>
            <span style={{ fontSize: 13, fontWeight: 800, color: '#15803D' }}>{nf(data.secured_financing_total)}</span>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th style={th}>Month</th><th style={th}>Title</th><th style={th}>Status</th><th style={{ ...th, textAlign: 'right' }}>Amount</th></tr></thead>
            <tbody>
              {data.secured_financing.map(u => (
                <tr key={u.id}>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{MONTHS[(u.month || 1) - 1]}</td>
                  <td style={{ ...td, fontWeight: 600 }}>{u.title || '—'}</td>
                  <td style={td}><span style={{ fontSize: 11, fontWeight: 700, padding: '2px 9px', borderRadius: 99, background: u.status === 'secured' ? '#DCFCE7' : '#DBEAFE', color: u.status === 'secured' ? '#15803D' : '#1D4ED8' }}>{u.status === 'secured' ? 'Secured' : 'Completed'}</span></td>
                  <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{u.amount != null ? nf(u.amount) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <SummaryTable title="CAPEX" accent="#4F46E5" block={data.capex} budgetLabel="Project Budget" />
      <SummaryTable title="OPEX" accent="#0EA5E9" block={data.opex} budgetLabel="Annual Budget" />
    </div>
  );
}
